var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"base-container"},[_c('b-row',{attrs:{"align-v":"center"}},_vm._l((_vm.members),function(member,key){return _c('b-col',{key:key,staticClass:"member-col"},[_c('TeamMember',{attrs:{"member":member}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }